export const SchoolType = {
  COMMUNITY_COLLEGE: 'Community College',
  COUNTING_ED_AND_DIRECT: 'Continuing Ed and Direct',
  UNIVERSITY: 'University',
  INTERNAL: 'Internal',
  OTHER: 'Other',
};
